import React from 'react';
import { Scale, CircuitBoard, Orbit } from 'lucide-react';

const iconMap = {
  softSkills: Scale,
  hardSkills: CircuitBoard,
  competencies: Orbit,
};

export const SkillCategoryIcon = ({ skill, size = 16, ...props }) => {
  if (!skill?.type) return null;

  const Icon = iconMap[skill.type];
  if (!Icon) return null;

  return (
    <Icon 
      size={size}
      style={{ 
        display: 'inline-block',
        verticalAlign: 'middle',
        marginRight: 6,
        flexShrink: 0
      }} 
      {...props}
    />
  );
};

